import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse, AxiosError } from "axios";
import { UnitDTO } from "../types/unitDTO";
import Problem from "../types/problem";
import apiClient from "../main/apiClient";

const useFetchUnits = (organisationId: string) => {
    return useQuery<UnitDTO[], AxiosError>({
        queryKey: ["unit"],
        queryFn: () =>
          apiClient.get(`/organisation/${organisationId}/unit`).then((resp) => resp.data),
    });
}

const useFetchUnit = (organisationId: string, unitId: string) => {
  return useQuery<UnitDTO, AxiosError>({
    queryKey: ["unit", unitId],
    queryFn: () =>
      apiClient.get(`/organisation/${organisationId}/unit/${unitId}`).then((resp) => resp.data),
  });
};

const useUpdateUnit = (organisationId: string) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, UnitDTO>({
    mutationFn: (unitDTO) => apiClient.put(`/organisation/${organisationId}/unit`, unitDTO),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["unit"] });
    }
  });
};

const useAddUnit = (organisationId: string, setUnitState: (unit: UnitDTO) => void) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, UnitDTO>({
    mutationFn: (unitDTO) => apiClient.post(`/organisation/${organisationId}/unit`, unitDTO),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["unit"] });
    },
    onError: (error, variables) => {
      console.log(error);
      setUnitState(variables);
    }
  });
};

const useDeleteUnit = (organisationId: string) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, UnitDTO>({
    mutationFn: (unitDTO) => apiClient.delete(`/organisation/${organisationId}/unit`, { data: unitDTO }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["unit"] });
      queryClient.invalidateQueries({ queryKey: ["terminal"] });
      queryClient.invalidateQueries({ queryKey: ["capabilitiesForUnits"] });
      queryClient.invalidateQueries({ queryKey: ["capabilitiesForUnitMission"] });
    }
  });
};

export { useFetchUnits, useFetchUnit, useUpdateUnit, useAddUnit, useDeleteUnit }
